module.exports = __webpack_public_path__ + "static/media/kevin88.decd747b.png";